module.exports = __webpack_public_path__ + "img/home_icon_user.63d40f2e.png";